module.exports = __webpack_public_path__ + "img/icon-enter.c4c1d1cc.svg";